export class FileToUpload {
    FileName: string = "";
    FileSize: number = 0;
    FileType: string = "";
    LastModifiedTime: number = 0;
    LastModifiedDate: string = "";
    FileAsBase64: string = "";
}
